import { useMediaQuery, useTheme } from "@mui/material";

export default () => {
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("sm"));

  return { fullScreen };
};
